import styled from 'styled-components'

export const FilterContainer = styled.div`
  position: relative;
`

export const FilterButton = styled.button`
  display: flex;
  align-items: center;
  gap: 10px;
  height: 42px;
  min-width: 174px;
  padding: 10px 16px;
  border: 1px solid rgba(244, 244, 246, 1);
  justify-content: space-between;
  border-radius: 8px;
  background: var(--color-white);
  font-size: 14px;
  font-weight: 400;
  color: var(--color-text-primary);
  cursor: pointer;
`

export const ChevronWrap = styled.span<{ isOpen?: boolean }>`
  display: inline-flex;
  align-items: center;
  transition: transform 0.2s ease;
  transform: rotate(${props => (props.isOpen ? '180deg' : '0deg')});
`

export const Menu = styled.div`
  position: absolute;
  top: calc(100% + 8px);
  left: 0;
  z-index: 100;
  min-width: 174px;
  padding: 4px 4px;
  background: var(--color-white);
  border: 1px solid var(--color-issabeline-grey);
  border-radius: 6px;
  box-shadow: 0px 4px 29px rgba(19, 69, 186, 0.15);
  overflow: hidden;
`

export const MenuItem = styled.button<{ isSelected?: boolean }>`
  display: block;
  width: 100%;
  padding: 8px 8px;
  border: none;
  background: ${props => (props.isSelected ? 'var(--color-breadcrumb-blue)' : 'transparent')};
  font-size: 14px;
  font-weight: 400;
  color: var(--color-text-primary);
  text-align: left;
  white-space: nowrap;
  cursor: pointer;

  &:hover {
    background: ${props => (props.isSelected ? 'var(--color-breadcrumb-blue)' : 'var(--color-selago-grey)')};
  }
`
